var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c(_vm.component,_vm._b({tag:"component",attrs:{"additionaldata":_vm.additionaldata,"id":_vm.id,"data-component-name":_vm.component}},'component',{ data: _vm.data },false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }